var exports = {
  "Wl": "EmbedImage.module__imagePreviewHandler___b28zaV",
  "kL": "EmbedImage.module__container___b28zaV",
  "qd": "EmbedImage.module__rowContainer___b28zaV",
  "Ub": "EmbedImage.module__justifyEnd___b28zaV",
  "WH": "EmbedImage.module__innerContainer___b28zaV",
  "h4": "EmbedImage.module__imageWrapper___b28zaV",
  "ZS": "EmbedImage.module__imageContainer___b28zaV",
  "dm": "EmbedImage.module__imageInnerContainer___b28zaV",
  "tN": "EmbedImage.module__blurContainer___b28zaV",
  "Iu": "EmbedImage.module__thumbHashContainer___b28zaV",
  "kv": "EmbedImage.module__thumbHashImage___b28zaV",
  "il": "EmbedImage.module__mediaContainer___b28zaV",
  "or": "EmbedImage.module__cursorPointer___b28zaV",
  "qH": "EmbedImage.module__imageElement___b28zaV",
  "bO": "EmbedImage.module__animatedImageElement___b28zaV",
};

module.exports = exports;
